<template>
	<div class="compliance-logos-list b360-grid-row">
		<FormLabelTooltip
			:required="true"
			:label="'Compliance Logos'"
			class="b360-col-12"
		></FormLabelTooltip>
		<div
			class="b360-col-xs-12 b360-col-sm-12 b360-col-md-6 b360-col-lg-6"
			v-for="(logo, index) in logoList"
			:key="index"
			@click="handleClick(index)"
		>
			<div
				class="compliance-logo--wrapper"
				:id="`logo-${logo.index}`"
				:class="{ checked: isSelectedLogo(index), disabled: disabledClass }"
			>
				<!--TODO: Fix Invalid v-model -->
				<!-- eslint-disable -->
				<input
					:name="`logo-hidden-checkbox-${index}`"
					class="hidden-checkbox"
					type="checkbox"
					required
					v-model="selectedLogos.length > 0"
				/>
				<div class="compliance-logo--img">
					<img
						v-if="logo.backgroundImage"
						:src="logo.backgroundImage"
						:alt="logo.category"
						:id="`logo-${logo.index}`"
					/>
					<div v-else class="compliance-logo--mass-license">
						<span><strong>No Logo</strong></span> <br />
						<span>(Massachusetts Only)</span>
					</div>
				</div>
				<CheckBox
					:checkboxId="`logo-checkbox-${logo.index}`"
					class="compliance-logo--checkbox"
					:isChecked="isSelectedLogo(index)"
					@click="handleClick(index)"
				></CheckBox>
			</div>
		</div>
	</div>
</template>

<script>
import CheckBox from '@/components/global/CheckBox.vue';
import FormLabelTooltip from '@/components/global/FormLabelTooltip.vue';

export default {
	name: 'ComplianceLogos',
	components: {
		CheckBox,
		FormLabelTooltip,
	},
	props: {
		logoList: Array,
		disabled: Boolean,
		disabledClass: Boolean,
		selectedLogos: Array,
	},
	methods: {
		handleClick(logo) {
			this.$emit('handle-click', logo);
		},
		isSelectedLogo(index) {
			return this.selectedLogos.includes(index + 1);
		},
	},
};
</script>

<style scoped lang="scss">
.compliance-logo {
	&--checkbox {
		position: absolute;
		&.checked {
			background-color: $brand-blue;
			box-shadow: 0 0 0 1px $brand-blue;
		}
	}

	&--wrapper {
		margin: 0;
		padding: 0;
		height: 100%;
		width: auto;
		position: relative;
		z-index: 1;

		&.disabled {
			background-color: $b360-color--gray__light;
			cursor: not-allowed;
		}
	}
}

.compliance-logo--mass-license {
	text-align: center;
}

@include lg {
	.license-list {
		@include rem('height', 300px);
	}

	.preview-content {
		@include rem('height', 280px);
	}
}

.title-description {
	grid-row-start: 1;
	grid-row-end: span 3;

	&.logo-title {
		grid-row-end: span 4;
	}

	@include lg {
		@include rem('padding-right', 25px);
	}
}

.hidden-checkbox {
	height: 1px;
	width: 1px;
	display: inline;
	position: absolute;
	z-index: 0;
	display: none;
}
</style>
